import { useEffect, useState } from 'react'

import { api, type Cliente, type Usuario } from './api'
import { Acceso } from './componentes/Acceso'
import { BuscarClientes } from './componentes/BuscarClientes'
import { Catalogo } from './componentes/Catalogo'
import { FichaCliente } from './componentes/FichaCliente'
import { Resumen } from './componentes/Resumen'
import { Usuarios } from './componentes/Usuarios'

type Vista = { tipo: 'resumen' } | { tipo: 'clientes'; buscar?: string } | { tipo: 'ficha'; clienteId: string } | { tipo: 'catalogo' } | { tipo: 'usuarios' }

export function App() {
  const [usuario, setUsuario] = useState<Usuario | null>(null)
  const [comprobando, setComprobando] = useState(true)
  const [vista, setVista] = useState<Vista>({ tipo: 'resumen' })

  useEffect(() => {
    api
      .yo()
      .then(({ usuario }) => setUsuario(usuario))
      .catch(() => setUsuario(null))
      .finally(() => setComprobando(false))
  }, [])

  if (comprobando) return <div className="cargando">Cargando…</div>
  if (!usuario) return <Acceso alEntrar={setUsuario} />

  const salir = async () => {
    await api.salir().catch(() => undefined)
    setUsuario(null)
    setVista({ tipo: 'resumen' })
  }

  const abrirCliente = (cliente: Cliente | string) =>
    setVista({ tipo: 'ficha', clienteId: typeof cliente === 'string' ? cliente : cliente.id })

  return (
    <div className="marco">
      <header className="barra">
        <div className="marca">
          <img src="https://www.sunsmartec.com/wp-content/uploads/2025/03/logo_sunsmartec.png" alt="SunSmart" />
          <span>Panel de cotizaciones</span>
        </div>
        <nav>
          <button className={vista.tipo === 'resumen' ? 'pestana activa' : 'pestana'} onClick={() => setVista({ tipo: 'resumen' })}>
            Resumen
          </button>
          <button
            className={vista.tipo === 'clientes' || vista.tipo === 'ficha' ? 'pestana activa' : 'pestana'}
            onClick={() => setVista({ tipo: 'clientes' })}
          >
            Clientes
          </button>
          <button className={vista.tipo === 'catalogo' ? 'pestana activa' : 'pestana'} onClick={() => setVista({ tipo: 'catalogo' })}>
            Catálogo
          </button>
          {usuario.rol === 'admin' && (
            <button
              className={vista.tipo === 'usuarios' ? 'pestana activa' : 'pestana'}
              onClick={() => setVista({ tipo: 'usuarios' })}
            >
              Usuarios
            </button>
          )}
        </nav>
        <div className="quien">
          <span>
            {usuario.nombre} <small>· {usuario.rol}</small>
          </span>
          <button className="enlace" onClick={salir}>
            Salir
          </button>
        </div>
      </header>

      <main className="contenido">
        {vista.tipo === 'resumen' && (
          <Resumen
            esAdmin={usuario.rol === 'admin'}
            alAbrirCliente={abrirCliente}
            alBuscar={(texto) => setVista({ tipo: 'clientes', buscar: texto })}
          />
        )}
        {vista.tipo === 'clientes' && <BuscarClientes key={vista.buscar ?? ''} inicial={vista.buscar} alAbrir={abrirCliente} />}
        {vista.tipo === 'ficha' && (
          <FichaCliente clienteId={vista.clienteId} alVolver={() => setVista({ tipo: 'clientes' })} />
        )}
        {vista.tipo === 'catalogo' && <Catalogo esAdmin={usuario.rol === 'admin'} />}
        {vista.tipo === 'usuarios' && usuario.rol === 'admin' && <Usuarios />}
      </main>
    </div>
  )
}
